<h1>Quality Control Configuration</h1>

<div class="p-grid">
  <div class="p-col-12 p-lg-6 p-xl-4">
    <p-card header="Builder Production Display Configuration" class="production-display-container">
      <form *ngIf="!loading && !error">
          <div class="form-group p-mb-1">
              <label for="safetyLevel">Safety Level</label>
              <p-dropdown [options]="safetyLevelOptions" [formControl]="safetyLevelControl" [editable]="false"
                  [autoDisplayFirst]="false" placeholder="Select Safety Level" appendTo="body" id="safetyLevel"
                  (onChange)="updateSafetyLevel()">
              </p-dropdown>
          </div>

          <div class="form-group">
              <label for="notes">News</label>
              <textarea pInputTextarea id="notes" [formControl]="newsAndNotesControl" rows="3" placeholder="Enter news"></textarea>

              <p-button type="button" class="p-button-success p-mt-2" label="Save News" [disabled]="newsAndNotesUpdating"
                  [loading]="newsAndNotesUpdating" (onClick)="updateNewsAndNotes()">
              </p-button>
          </div>
      </form>
      <div *ngIf="error" class="p-mt-2">
        <span aria-live="polite" aria-label="Error">{{ error }}</span>
      </div>
      <div *ngIf="loading">
        <span class="pi pi-spin pi-spinner" aria-label="Loading"></span>
      </div>
    </p-card>
  </div>
</div>
